import { Component, Input, inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService, Theme } from '../../../core/services/theme.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-prism-logo',
  imports: [CommonModule],
  templateUrl: './prism-logo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [],
})
export class PrismLogoComponent implements OnDestroy {
  themeservice = inject(ThemeService);
  @Input() className: string = '';

  isDark: boolean = this.themeservice.getTheme() === 'dark';

  private themeSubscription: Subscription;

  constructor() {
    this.themeSubscription = this.themeservice.getThemeObservable().subscribe(theme => {
      this.isDark = theme === 'dark';
    });
  }

  ngOnDestroy(): void {
    this.themeSubscription.unsubscribe();
  }

  get primaryColor(): string {
    return this.isDark ? '#8b5cf6' : '#7c3aed';
  }

  get secondaryColor(): string {
    return this.isDark ? '#6366f1' : '#4f46e5';
  }

  get accentColor(): string {
    return this.isDark ? '#a78bfa' : '#8b5cf6';
  }

  get glowColor(): string {
    return this.isDark ? '#c084fc' : '#a78bfa';
  }

  private readonly uniqueId = Math.random().toString(36).substring(2, 9);

  get gradientId(): string {
    return `prismGradient-${this.uniqueId}-${this.isDark ? 'dark' : 'light'}`;
  }

  get accentGradientId(): string {
    return `accentGradient-${this.uniqueId}-${this.isDark ? 'dark' : 'light'}`;
  }

  get radialGradientId(): string {
    return `radialGradient-${this.uniqueId}-${this.isDark ? 'dark' : 'light'}`;
  }

  get glowFilterId(): string {
    return `glow-${this.uniqueId}-${this.isDark ? 'dark' : 'light'}`;
  }

  get strongGlowFilterId(): string {
    return `strongGlow-${this.uniqueId}-${this.isDark ? 'dark' : 'light'}`;
  }
}
